import { CardImage } from '@blueprint/card';
import { Image } from '../graphql.generated';
import { ImagePlaceholder } from '@zoopla/assets';

import getListingImage from './getListingImage';
import {
    CardImagePlaceholder,
    ListingFlag,
    ListingImageCount,
    PropertyImage
} from './ListingImage.styles';
import { CameraMinifillSmall } from '@blueprint/icons';

type ListingImageProps = {
    count?: number | null | undefined;
    image?: Image | null | undefined;
    useImagePlaceholder?: boolean;
    flag?: string | null | undefined;
    sizes?: string;
    useImageLazyLoad?: boolean;
};

const ListingImage = ({
    count,
    image,
    useImagePlaceholder = true,
    flag,
    sizes = '17.5rem',
    useImageLazyLoad = false
}: ListingImageProps) => {
    const listingImage = getListingImage(image);
    const hasImage = Boolean(listingImage.src);

    return (
        <PropertyImage>
            {flag && <ListingFlag>{flag}</ListingFlag>}

            {hasImage && (
                <>
                    <CardImage
                        sizes={sizes}
                        src={listingImage.src}
                        responsiveImgList={listingImage.responsiveImgList}
                        alt={`Listing photo${
                            listingImage.alt ? ` - ${listingImage.alt}` : ''
                        }`}
                        data-testid="property-img"
                        lazy={useImageLazyLoad}
                        loading={useImageLazyLoad ? 'lazy' : undefined}
                    />
                    {count && (
                        <ListingImageCount>
                            <CameraMinifillSmall />
                            {count}
                        </ListingImageCount>
                    )}
                </>
            )}

            {!hasImage && useImagePlaceholder && (
                <CardImagePlaceholder>
                    <img
                        width="90"
                        src={ImagePlaceholder}
                        role="presentation"
                        data-testid="property-img-placeholder"
                        loading="lazy"
                        alt=""
                    />
                </CardImagePlaceholder>
            )}
        </PropertyImage>
    );
};

export default ListingImage;
export { PropertyImage, CardImagePlaceholder };
